export enum ViewName {
  RiskInbox = 'Risk inbox',
  RiskInboxDrawer = 'Risk inbox drawer',
  organizationCard = 'Organization card',
  paymentCard = 'Payment card',
  vendorMelioMeCard = 'Vendor melioMe card',
  vendorCard = 'Vendor card',
  sanctionsCard = 'Sanctions card',
  deliveryMethodCard = 'Delivery Method card',
  fundingSourceCard = 'Funding Source card',
  ipPayorCard = 'IP Payor card',
  ipPaymentCard = 'IP Payment card',
  ipUpdateCard = 'IP Update card',
  ipPayeeCard = 'IP Payee card',
  RecoChecks = 'Reco checks',
  RecoAch = 'Reco ach',
  RecoRejectCheck = 'Reco reject',
  RecoCard = 'Reco card',
  RecoCardActionRequired = 'Reco card action required',
  RecoVendorBalance = 'Reco vendor balance',
  RecoVendorAdjustment = 'Reco vendor Adjustment',
  sherlockEscalationTable = 'Sherlock escalation table',
  sherlockEscalationDrawer = 'Sherlock escalation drawer',
  sherlockOrganizationTable = 'Sherlock organization table',
  sherlockOrganizationPersonalTable = 'Sherlock organization personal table',
  sherlockAccountViewEscalationTable = 'Sherlock account view escalation table',
  sherlockSpecificEscalationTable = 'Sherlock specific escalation table',
  sherlockDecisionTaggingTable = 'Sherlock decision tagging table',
  sherlockDecisionTaggingDrawer = 'Sherlock decision tagging drawer',
  SherlockDecisionTaggingOrganizationCard = 'Sherlock decision tagging organization card',
  sherlockProjectsTableOpenTab = 'Sherlock projects table Open Tab',
  sherlockProjectsTableArchiveTab = 'Sherlock projects table Archive Tab',
  AccountViewUserTable = 'Account view user table',
  AccountViewUserAdvancedTable = 'Account view user advanced table',
  AccountViewFundingSource = 'Account view funding source table',
  AccountViewVendorTable = 'Account view vendor table',
  AccountViewPayorsTable = 'Account view payors table',
  SherlockEscalationCluster = 'Sherlock escalation cluster',
  SherlockRequestForInformationCluster = 'Sherlock Request for information cluster',
  AccountViewVendorCard = 'Account view vendor card',
  AccountViewMelioMeCard = 'Account view MelioMe card',
  AccountViewActivityKyc = 'Account view activity kyc',
  AccountViewActivityKycUbo = 'Account view activity kyc ubo',
  AccountViewFileAttachment = 'Account view file attachment',
  AccountViewFileAttachmentManageFileMetadata = 'Account view file attachment manage file metadata',
  AccountViewFileIdmKyc = 'Account view idm kyc',
  AccountViewTaxVerificationAdd = 'Account view tax verification add',
  AccountViewTaxVerificationRowEdit = 'Account view tax verification row edit',
  AccountViewIp = 'Account view ip',
  PayorPaymentHistoryTab = 'Payor payment history tab',
  AccountViewPaymentsTab = 'Account view payments tab',
  AccountViewFraudReferralCurrentTab = 'Account view fraud referral current tab',
  AccountViewFraudReferralPreviousTab = 'Account view fraud referral previous tab',

  // busy
  busyVerificationTasksTable = 'Busy table (verification tasks)',
  busyVerificationGroupTasksTable = 'Busy table (verification group tasks)',
  busyCompletedVerificationTasksTable = 'Busy table (completed verification tasks)',
  busyEscalatedVerificationTasksTable = 'Busy table (escalated verification tasks)',
  busyUnmatchTasksTable = 'Busy table (pending unmatch tasks)',

  // tagging management
  TaggingManagementAllTags = 'Tagging management all tags'
}
